import { isNotEmptyValue } from "kwikid-toolkit";
import {
  TKwikUIAnimationPlayerType,
  VKwikUIAnimationPlayerType
} from "./animation-player.definitions";

export const isValidKeyValue = (key: string, value: any): boolean => {
  const isString = (x: string) => typeof x === "string";

  const methods = {
    config: (x: any) => isNotEmptyValue(x),
    id: isString,
    player: (x: TKwikUIAnimationPlayerType) =>
      VKwikUIAnimationPlayerType.includes(x)
  };

  return methods[key] && methods[key](value);
};
